import { Input, Modal, Select, Slider } from 'antd';
import { replace } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import { setBranchInfo } from '../actions/branchAction';
import { agreeSms, updateCalculateHour } from '../actions/loginAction';

import {
  setKeyboardSetting,
  setMultiPosSetting,
  setVolumeSetting,
} from '../actions/posAction';
import { changeAgreeSmsAsync, changeAutoChargeAsync } from '../api/api';
import { httpGet, httpPost, httpUrl } from '../api/httpClient';
import ClickSwitch from '../components/input/ClickSwitch';
import BlindModal from '../components/modal/BlindModal';
import ChargeModal from '../components/modal/ChargeModal';
import GuideModal from '../components/modal/GuideModal';
import PasswordModal from '../components/modal/PasswordModal';
import PaystoryChargeModal from '../components/modal/PaystoryChargeModal';
import PosOrderRelaionAppModal from '../components/modal/PosOrderRelaionAppModal';
import Const from '../const';
import {
  getMultiPosSettings,
  getNotifyCidPort,
  getNotifyPosOrderPort,
  getPosOrderAllowDuplicates,
  getPsBaeminSetting,
  getUseNotifyChat,
  getUseNotifyCid,
  getUseNotifyOrderAssign,
  getUseNotifyOrderComplete,
  getUseNotifyOrderEtc,
  getUseNotifyOrderNew,
  getUseNotifyOrderPickUp,
  getUseNotifyPosOrder,
  getVrKeyboardSetting,
  getUseAutoConfirmOrder,
  getAutoConfirmPickupTime,
  setMultiPosSettings,
  setNotifyCidPort,
  setNotifyPosOrderPort,
  setPosOrderAllowDuplicates,
  setPosOrderRelationAppAllowDuplicates,
  SetUseNotifyChat,
  setUseNotifyCid,
  SetUseNotifyOrderAssign,
  SetUseNotifyOrderComplete,
  SetUseNotifyOrderEtc,
  SetUseNotifyOrderNew,
  SetUseNotifyOrderPickUp,
  setUseNotifyPosOrder,
  setVrKeyboardSetting,
  setUseAutoConfirmOrder,
  setAutoConfirmPickupTime,
} from '../lib/module';
import {getFrStatusString, modalStyle, modalErrorStyle, pickupTimeValue} from '../lib/util/codeUtil';
import { comma } from '../lib/util/numberUtil';
import YogiyoSetting from "../components/yogiyo/YogiyoSetting";
import string from '../res/string';
import image from '../res/image';

class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkMenu: 0,
      settingType: 0,
      guideModalOpen: false,
      posOrderRelationAppModalOpen: false,
      pwModalOpen: false,

      notifyAll: false,
      notifyOrderNew: false,
      notifyOrderAssign: false,
      notifyOrderPickUp: false,
      notifyOrderComplete: false,
      notifyOrderEtc: false,
      notifyChat: false,

      autoCharge: null,

      notifyPosOrder: Const.posOrderEnable,
      posOrderPort: Const.posOrderPort,
      posOrderAllowDuplicates: false,

      notifyCid: Const.cidRelationAppEnable,
      cidPort: Const.cidPort,
      cidAllowDuplicates: false,

      dong: [],
      selectedDong: [],

      psBaeminSetting: false,
      keyboardSetting: false,
      useAutoConfirmOrder: false,
      autoConfirmPickupTime: Const.autoConfirmPickupTime,
      multiPosSetting: false,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      notifyAll:
        getUseNotifyOrderNew() &&
        getUseNotifyOrderAssign() &&
        getUseNotifyOrderComplete() &&
        getUseNotifyOrderEtc() &&
        getUseNotifyChat(),
      notifyOrderNew: getUseNotifyOrderNew(),
      notifyOrderAssign: getUseNotifyOrderAssign(),
      notifyOrderPickUp: getUseNotifyOrderPickUp(),
      notifyOrderComplete: getUseNotifyOrderComplete(),
      notifyOrderEtc: getUseNotifyOrderEtc(),
      notifyChat: getUseNotifyChat(),

      notifyPosOrder: getUseNotifyPosOrder(),
      posOrderPort: getNotifyPosOrderPort(),
      posOrderAllowDuplicates: getPosOrderAllowDuplicates(),

      notifyCid: getUseNotifyCid(),
      cidPort: getNotifyCidPort(),
      keyboardSetting: getVrKeyboardSetting(),
      useAutoConfirmOrder: getUseAutoConfirmOrder(),
      autoConfirmPickupTime: getAutoConfirmPickupTime(),
      multiPosSetting: getMultiPosSettings(),
      psBaeminSetting: getPsBaeminSetting(),
    });
    this.getAutoCharge();
    this.getSimpleDong();
    this.initializePsBaeminSetting();
  }

  isPsFr = (frOrderAgencyList) => {
    return frOrderAgencyList &&
      frOrderAgencyList.filter((foa) => foa.posCode === 'psCode').length > 0
      ? true
      : false;
  };

  initializePsBaeminSetting = async () => {
    if (this.isPsFr(this.props.loginReducer.loginInfo.frOrderAgency)) {
      if (typeof global.psBaeminSetting === 'boolean') {
        this.setState({
          psBaeminSetting: global.psBaeminSetting,
        });
        return;
      }
      const prevSetting = reactLocalStorage.getObject(
        Const.appName + '#psBaeminSetting'
      );
      if (typeof prevSetting === 'boolean')
        this.setState({ psBaeminSetting: prevSetting });
    }
  };

  getAutoCharge = async () => {
    const res = await httpGet(httpUrl.autoCharge, [], {});
    if (res.result !== 'SUCCESS') {
      return;
    }
    this.setState({ autoCharge: res.data });

    // 주소목록에서 간편동설정으로 바로 넘어가기
    if (this.props.location.state) {
      this.setState({ settingType: 2, checkMenu: 2 });
    }
  };

  getSimpleDong = () => {
    let addrDeliveryData = reactLocalStorage.getObject(
      Const.appName + '#addrDelivery'
    );

    addrDeliveryData.forEach((item) => {
      item.name = item.eupMyeonDong;
      item.siDo = item.siDo;
      item.siGunGu = item.siGunGu;
    });

    let getSelectSimpleDong = reactLocalStorage.getObject(
      Const.appName + '#selectSimpleDong'
    );

    if (getSelectSimpleDong.length > 0) {
      let listIdx = getSelectSimpleDong.map((x) => x.idx);
      let list = addrDeliveryData.filter((x) => !listIdx.includes(x.idx));

      this.setState({
        selectedDong: this.state.selectedDong.concat(getSelectSimpleDong),
        dong: this.state.dong.concat(list),
      });
    } else {
      this.setState({
        selectedDong: [],
        dong: [...addrDeliveryData],
      });
    }
  };

  getPickupTimeText = (value)=> {
    return value > 1000 ? `후${value % 1000}분` : `${value}분`;
  };

  onCheck = (id) => {
    this.setState({ checkMenu: id });
  };

  onChangeAutoCharge = (flag) => {
    if (
      !this.state.autoCharge.cardNum ||
      this.state.autoCharge.cardNum.length <= 12
    ) {
      Modal.info({
        title: '자동결제',
        content: <div>카드설정버튼을 클릭하여 먼저 카드를 등록해주세요.</div>,
        ...modalStyle,
        onOk() {},
      });
      return;
    }
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: flag
        ? '예치금 충전 자동결제를 활성화 하시겠습니까?'
        : '예치금 충전 자동결제를 비활성 하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        changeAutoChargeAsync(flag).then((result) => {
          if (result === 'SUCCESS') {
            self.setState({
              autoCharge: {
                ...self.state.autoCharge,
                enabled: flag,
              },
            });
          } else {
            Modal.error({
              title: '예치금 충전 자동결제 설정 오류',
              content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
              ...modalErrorStyle,
            });
          }
        });
      },
      onCancel() {},
    });
  };
  onChangeAgreeSms = (flag) => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: flag
        ? 'SMS로 공지사항 및 이벤트정보 수신에 동의하시겠습니까?'
        : 'SMS로 공지사항 및 이벤트 혜택을 받을 수 없습니다. 그래도 해지 하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        changeAgreeSmsAsync(flag).then((result) => {
          if (result === 'SUCCESS') {
            self.props.agreeSms(flag);
          } else {
            Modal.error({
              title: 'SMS로 공지사항 및 이벤트정보 수신 설정 오류',
              content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
              ...modalErrorStyle,
            });
          }
        });
      },
      onCancel() {},
    });
  };
  onChangePosOrderPort = () => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: 'POS연동 포트를 변경 하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        setNotifyPosOrderPort(self.state.posOrderPort);
      },
      onCancel() {},
    });
  };

  onChangeCidPort = () => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: 'C I D 연동 포트를 변경 하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        setNotifyCidPort(self.state.cidPort);
      },
      onCancel() {},
    });
  };


  handleVolumeChange = (volume) => {
    this.props.setVolumeSetting(volume / 100);
  };

  onChangeOrderStatusSetting = (value) => {
    this.props.setOrderStatusTableSetting(value);
  };

  // 배송가이드 모달
  openGuideModal = () => {
    this.setState({ guideModalOpen: true });
  };
  closeGuideModal = () => {
    this.setState({ guideModalOpen: false });
  };
  // 비밀번호 변경 모달
  openPwModal = () => {
    this.setState({ pwModalOpen: true });
  };
  closePwModal = () => {
    this.setState({ pwModalOpen: false });
  };
  onRemoteSupport = () => {
    window.open(Const.remoteSupportUrl);
  };

  //SUB POS 연동 모달
  openPosOrderRelationAppModal = () => {
    this.setState({ posOrderRelationAppModalOpen: true });
  };
  closePosOrderRelationAppModal = () => {
    this.setState({ posOrderRelationAppModalOpen: false });
  };

  handleSubmit = () => {
    let selectSimpleList = this.state.selectedDong;
    Modal.confirm({
      content: '간편동을 편집하시겠습니까?',
      ...modalStyle,
      okText: '확인',
      cancelText: '취소',
      onOk() {
        reactLocalStorage.setObject(
          Const.appName + '#selectSimpleDong',
          selectSimpleList
        );
      },
    });
  };

  render() {
    const skinType = Const.skinType.toUpperCase();
    return (
      <div className="setting">
        <div className="setting-bg">
          <div className="setting-content">
            <div className="setting-content-all">
              <div
                className="setting-content-title"
                onClick={() => {
                  this.onCheck(0);
                  this.setState({ settingType: 0 });
                }}>
                <div
                  className={this.state.checkMenu === 0 && skinType === "GOGOIT" ?
                      'gogoit-setting-content-title-text-color':
                      this.state.checkMenu === 0
                      ? 'setting-content-title-text-color'
                      : 'setting-content-title-text'
                  }>
                  기본정보
                </div>
              </div>
              <div
                className="setting-content-title2"
                onClick={() => {
                  this.onCheck(1);
                  this.setState({ settingType: 1 });
                }}>
                <div
                  className={this.state.checkMenu === 1 && skinType === "GOGOIT" ?
                      'gogoit-setting-content-title2-text-color':
                    this.state.checkMenu === 1
                      ? 'setting-content-title2-text-color'
                      : 'setting-content-title2-text'
                  }>
                  POS설정
                </div>
              </div>
              <div
                className="setting-content-title3"
                onClick={this.openGuideModal}>
                배송가이드
              </div>
              <GuideModal
                isOpen={this.state.guideModalOpen}
                close={this.closeGuideModal}
              />
              <div
                className="setting-content-title3"
                onClick={this.openPosOrderRelationAppModal}
                style={{
                  color: 'white',
                  float: 'right',
                  fontSize: 10,
                  marginRight: 35,
                }}>
                SUB POS 연동
              </div>
              <PosOrderRelaionAppModal
                isOpen={this.state.posOrderRelationAppModalOpen}
                close={this.closePosOrderRelationAppModal}
              />
              <div
                className="setting-content-title2 mobileoff"
                onClick={() => {
                  this.onCheck(2);
                  this.setState({ settingType: 2 });
                }}>
                <div
                  className={this.state.checkMenu === 2 && skinType === "GOGOIT" ?
                      'gogoit-setting-content-title2-text-color':
                      this.state.checkMenu === 2
                          ? 'setting-content-title2-text-color'
                          : 'setting-content-title2-text'
                  }>
                  간편동 설정
                </div>
              </div>
              <div
                  className="setting-content-title2 mobileoff"
                  onClick={() => {
                    this.onCheck(3);
                    this.setState({ settingType: 3 });
                  }}>
                <div
                    className={this.state.checkMenu === 3 && skinType === "GOGOIT" ?
                        'gogoit-setting-content-title2-text-color':
                        this.state.checkMenu === 3
                            ? 'setting-content-title2-text-color'
                            : 'setting-content-title2-text'
                    }>
                  y연동설정
                </div>
              </div>

            </div>
          </div>
          {/* 기본정보 */}
          {this.state.settingType === 0 && (
            <div className="setting-element">
              <div className="setting-element-all desk ">
                {/* 상점 기본정보 */}
                <div className="setting-element-block">
                  <div className="setting-element-block-title">
                    상점 기본 정보
                  </div>
                  <div className="setting-element-block-content">
                    <div className="setting-element-block-content-field">
                      <div className="setting-element-block-content-field-text">
                        상호이름 :
                      </div>
                      <div className="setting-element-block-content-field-text2">
                        {this.props.loginReducer.loginInfo.frName}
                      </div>
                    </div>
                    <div className="setting-element-block-content-field">
                      <div className="setting-element-block-content-field-text">
                        상호번호 :
                      </div>
                      <div className="setting-element-block-content-field2-text2">
                        {this.props.loginReducer.loginInfo.businessNumber}
                      </div>
                    </div>
                    <div className="setting-element-block-content-field">
                      <div className="setting-element-block-content-field-text">
                        상점아이디 :
                      </div>
                      <div className="setting-element-block-content-field-text2">
                        {this.props.loginReducer.loginInfo.id}
                        {/* 0319819868 */}
                      </div>
                    </div>
                    <div className="setting-element-block-content-field">
                      <div className="setting-element-block-content-field-text">
                        전화번호 :
                      </div>
                      <div className="setting-element-block-content-field-text2">
                        {this.props.loginReducer.loginInfo.frPhone}
                      </div>
                    </div>
                    {/* <div className="setting-element-block-content-field">
                                            <div className="setting-element-block-content-field4-text">
                                                운영시간 :
                                            </div>
                                            <div className="setting-element-block-content-field4-text2">
                                                월 00 : 00 ~ 02 : 50, 10 : 00 ~ 24 : 00

                                        </div> */}
                    <div className="setting-element-block-content-field">
                      <div className="setting-element-block-content-field-text">
                        운영상태 :
                      </div>
                      <div className="setting-element-block-content-field-text2">
                        {getFrStatusString(
                          this.props.loginReducer.loginInfo.frStatus
                        )}
                      </div>
                    </div>
                    <div className="setting-element-block-content-field">
                      <div className="setting-element-block-content-field-text">
                        상점주소 :
                      </div>
                      <div className="setting-element-block-content-field-text2">
                        {this.props.loginReducer.loginInfo.addr1}
                        {this.props.loginReducer.loginInfo.addr2}
                      </div>
                    </div>
                  </div>
                </div>

                {/* 계좌정보 */}
                <div className="setting-element-block2 desk">
                  <div className="setting-element-block2-title">계좌정보</div>
                  <div className="setting-element-block2-content">
                    <div className="setting-element-block2-content-field">
                      <div className="setting-element-block2-content-field-text">
                        은행이름 :
                      </div>
                      <div className="setting-element-block2-content-field-text2">
                        {this.props.loginReducer.loginInfo.prepayBank}
                      </div>
                    </div>
                    <div className="setting-element-block2-content-field">
                      <div className="setting-element-block2-content-field-text">
                        예금주 :
                      </div>
                      <div className="setting-element-block2-content-field-text3">
                        {this.props.loginReducer.loginInfo.prepayDepositor}
                      </div>
                    </div>
                    <div className="setting-element-block2-content-field">
                      <div className="setting-element-block2-content-field-text">
                        계좌번호 :
                      </div>
                      <div className="setting-element-block2-content-field-text2">
                        {this.props.loginReducer.loginInfo.prepayAccount}
                      </div>
                    </div>
                  </div>
                </div>
                {/* 비밀번호 변경, 원격지원 버튼 */}
                <div className="setting-element-block3 desk">
                  <div
                    className={skinType === "GOGOIT" ? "gogoit-setting-element-block3-btn" : "setting-element-block3-btn"}
                    onClick={this.openPwModal}>
                    비밀번호 변경
                  </div>
                  <PasswordModal
                    isOpen={this.state.pwModalOpen}
                    close={this.closePwModal}
                  />
                  {skinType === 'NNBOX' &&
                      <div
                          className="setting-element-block3-btn2"
                          onClick={() => {
                            this.onRemoteSupport();
                          }}>
                        원격지원
                      </div>
                  }
                </div>
              </div>

              {/* 상점기본정보-반응형 */}
              <div className="setting-content-box pos">
                <div>
                  <div className="setting-title">상점 기본 정보</div>

                  <div className="setting-box">
                    <ul>
                      <li>
                        <p>상호이름</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.frName} </p>
                      </li>
                      <li>
                        <p>상호번호</p>:{' '}
                        <p style={{ color: '#ff8a00' }}>
                          {' '}
                          {
                            this.props.loginReducer.loginInfo.businessNumber
                          }{' '}
                        </p>
                      </li>
                      <li>
                        <p>상점아이디</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.id} </p>
                      </li>
                      <li>
                        <p>전화번호</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.frPhone} </p>
                      </li>
                      {/* <li><p>운영시간</p>: <p> 월 00 : 00 ~ 02 : 50, 10 : 00 ~ 24 : 00 </p></li> */}
                      <li>
                        <p>운영상태</p>:{' '}
                        <p>
                          {' '}
                          {getFrStatusString(
                            this.props.loginReducer.loginInfo.frStatus
                          )}{' '}
                        </p>
                      </li>
                      <li>
                        <p>상점주소</p>:{' '}
                        <p>
                          {' '}
                          {this.props.loginReducer.loginInfo.addr1}
                          {this.props.loginReducer.loginInfo.addr2}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <div className="setting-title">계좌정보</div>
                  <div className="setting-box">
                    <ul>
                      <li>
                        <p>은행이름</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.prepayBank} </p>
                      </li>
                      <li>
                        <p>예금주</p>:{' '}
                        <p style={{ color: '#498bc9' }}>
                          {' '}
                          {
                            this.props.loginReducer.loginInfo.prepayDepositor
                          }{' '}
                        </p>
                      </li>
                      <li>
                        <p>계좌번호</p>:{' '}
                        <p>
                          {' '}
                          {this.props.loginReducer.loginInfo.prepayAccount}{' '}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* 비밀번호, 원격지원 버튼 -반응형 */}
                <div className={skinType === "GOGOIT" ? "gogoit-setting-btn-box" : "setting-btn-box"}>
                  <div onClick={this.openPwModal}>비밀번호 변경</div>
                  <PasswordModal
                    isOpen={this.state.pwModalOpen}
                    close={this.closePwModal}
                  />
                  {skinType === 'NNBOX' &&
                      <div
                          onClick={() => {
                            this.onRemoteSupport();
                          }}>
                        원격지원
                      </div>
                  }
                </div>
              </div>

              {/* 상점기본정보-모바일형 */}
              <div className="setting-content-box mobile">
                <div>
                  <div className="setting-title">상점 기본 정보</div>

                  <div className="setting-box">
                    <ul>
                      <li>
                        <p>상호이름</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.frName} </p>
                      </li>
                      <li>
                        <p>상호번호</p>:{' '}
                        <p style={{ color: '#ff8a00' }}>
                          {' '}
                          {
                            this.props.loginReducer.loginInfo.businessNumber
                          }{' '}
                        </p>
                      </li>
                      <li>
                        <p>상점아이디</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.id} </p>
                      </li>
                      <li>
                        <p>전화번호</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.frPhone} </p>
                      </li>
                      {/* <li><p>운영시간</p><p>:</p> <p> 월 00 : 00 ~ 02 : 50, <br/>10 : 00 ~ 24 : 00 </p></li> */}
                      <li>
                        <p>운영상태</p>:{' '}
                        <p>
                          {' '}
                          {getFrStatusString(
                            this.props.loginReducer.loginInfo.frStatus
                          )}{' '}
                        </p>
                      </li>
                      <li>
                        <p>상점주소</p>:{' '}
                        <p>
                          {' '}
                          {this.props.loginReducer.loginInfo.addr1}
                          {this.props.loginReducer.loginInfo.addr2}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <div className="setting-title">계좌정보</div>
                  <div className="setting-box">
                    <ul>
                      <li>
                        <p>은행이름</p>:{' '}
                        <p> {this.props.loginReducer.loginInfo.prepayBank} </p>
                      </li>
                      <li>
                        <p>예금주</p>:{' '}
                        <p style={{ color: '#498bc9' }}>
                          {' '}
                          {
                            this.props.loginReducer.loginInfo.prepayDepositor
                          }{' '}
                        </p>
                      </li>
                      <li>
                        <p>계좌번호</p>:{' '}
                        <p>
                          {' '}
                          {this.props.loginReducer.loginInfo.prepayAccount}{' '}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* 비밀번호, 원격지원 버튼 -반응형 */}
                <PasswordModal
                  isOpen={this.state.pwModalOpen}
                  close={this.closePwModal}
                />
                <div className={skinType === "GOGOIT" ? "gogoit-setting-btn-box" : "setting-btn-box"}>
                  {/* <div onClick={() => { this.onRemoteSupport(); }}>
                                        원격지원
                                    </div> */}
                  <div onClick={this.openPwModal}>비밀번호 변경</div>
                </div>
              </div>
            </div>
          )}

          {/* POS설정 */}
          {this.state.settingType === 1 && (
            <div className="pos-element">
              <div className="pos-element-all">
                {/* 알림설정 - 기본형*/}
                <div className="pos-element-block mobileoff">
                  <div className="pos-element-block-content">
                    <div className="pos-element-block-content-left mobileoff">
                      <div>
                        <div className="pos-element-block-content-text">
                          [전체알림]
                        </div>
                        <ClickSwitch
                          flag={this.state.notifyAll}
                          onChange={(flag) => {
                            this.setState({
                              notifyAll: flag,
                              notifyOrderNew: flag,
                              notifyOrderAssign: flag,
                              notifyOrderPickUp: flag,
                              notifyOrderComplete: flag,
                              notifyOrderEtc: flag,
                              notifyChat: flag,
                            });
                            SetUseNotifyOrderNew(flag);
                            SetUseNotifyOrderAssign(flag);
                            SetUseNotifyOrderPickUp(flag);
                            SetUseNotifyOrderComplete(flag);
                            SetUseNotifyOrderEtc(flag);
                            SetUseNotifyChat(flag);
                          }}
                        />
                        <div className="pos-element-block-content-text2">
                          [채팅]
                        </div>
                        <ClickSwitch
                          flag={this.state.notifyChat}
                          onChange={(flag) => {
                            this.setState({
                              notifyChat: flag,
                              notifyAll:
                                flag &&
                                this.state.notifyOrderNew &&
                                this.state.notifyOrderAssign &&
                                this.state.notifyOrderPickUp &&
                                this.state.notifyOrderComplete &&
                                this.state.notifyOrderEtc,
                            });
                            SetUseNotifyChat(flag);
                          }}
                        />
                        <div className="pos-element-block-content-text2">
                          [기타]
                        </div>
                        <ClickSwitch
                          flag={this.state.notifyOrderEtc}
                          onChange={(flag) => {
                            this.setState({
                              notifyOrderEtc: flag,
                              notifyAll:
                                flag &&
                                this.state.notifyOrderNew &&
                                this.state.notifyOrderAssign &&
                                this.state.notifyOrderPickUp &&
                                this.state.notifyOrderComplete &&
                                this.state.notifyChat,
                            });
                            SetUseNotifyOrderEtc(flag);
                          }}
                        />
                      </div>
                      <div className="pos-element-block-content-text">
                        [주문]
                      </div>
                      <div className="pos-element-block-content-text2">
                        접수
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderNew}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderNew: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderNew(flag);
                        }}
                      />
                      <div className="pos-element-block-content-text2">
                        배정
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderAssign}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderAssign: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderAssign(flag);
                        }}
                      />
                      <div className="pos-element-block-content-text2">
                        픽업
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderPickUp}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderPickUp: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderPickUp(flag);
                        }}
                      />
                      <div className="pos-element-block-content-text2">
                        완료
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderComplete}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderComplete: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderComplete(flag);
                        }}
                      />
                      {/* <div className="pos-element-block-content-img2">
                                            <Switch checkedChildren="ON" unCheckedChildren="OFF" defaultChecked />
                                        </div> */}

                      <div>
                        <div className="pos-element-block-content-text6 desk">
                          볼륨설정
                          <Slider
                            defaultValue={this.props.posReducer.volume * 100}
                            style={{ width: 400 }}
                            onChange={(volume) =>
                              this.handleVolumeChange(volume)
                            }
                          />
                        </div>
                      </div>
                      <div>
                        <div className="pos-element-block-content-text6 pos">
                          볼륨설정
                          <Slider
                            defaultValue={this.props.posReducer.volume * 100}
                            style={{ width: 350 }}
                            onChange={(volume) =>
                              this.handleVolumeChange(volume)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="pos-port pos-element-block-content-left mobileoff">
                      <div>
                        <div className="pos-element-block-content-text4">
                          POS 연동
                        </div>
                        <ClickSwitch
                          flag={this.state.notifyPosOrder}
                          onChange={(flag) => {
                            this.setState({ notifyPosOrder: flag });
                            setUseNotifyPosOrder(flag);
                          }}
                        />
                        <div className="pos-element-block-content-text5">
                          <div className="pos-element-block-content-field-port">
                            <Input
                              type="number"
                              value={this.state.posOrderPort}
                              onFocus={() => {}}
                              autoComplete="off"
                              placeholder="Port"
                              style={{ borderRadius: '7px', fontSize: '11px' }}
                              maxLength={6}
                              onChange={(e) => {
                                this.setState({
                                  posOrderPort: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div
                            className={skinType === "GOGOIT" ? "gogoit-pos-element-block5-content-btn2": "pos-element-block5-content-btn2"}
                            onClick={() => {
                              this.onChangePosOrderPort();
                            }}>
                            변경
                          </div>
                        </div>
                      </div>
                      {this.props.loginReducer.loginInfo.frOrderAgency.filter(
                        (foa) => foa.posCode === 'psCode'
                      ).length > 0 && (
                        <div>
                          <div className="pos-element-block-content-text4">
                            포스피드/배민연동
                          </div>
                          <div className="pos-element-block-content-text5">
                            <ClickSwitch
                              flag={this.state.psBaeminSetting}
                              onChange={(flag) => {
                                this.setState({ psBaeminSetting: flag }, () => {
                                  global.psBaeminSetting = flag;
                                  reactLocalStorage.setObject(
                                    Const.appName + '#psBaeminSetting',
                                    flag
                                  );
                                });
                              }}
                            />
                          </div>
                        </div>
                      )}
                      <div>
                        <div className="pos-element-block-content-text4-1">
                          중복 허용
                        </div>
                        <ClickSwitch
                          flag={this.state.posOrderAllowDuplicates}
                          onChange={(flag) => {
                            this.setState({ posOrderAllowDuplicates: flag });
                            setPosOrderAllowDuplicates(flag);
                          }}
                        />
                      </div>
                      <div>
                        <div className="pos-element-block-content-text4">
                          C I D 연동
                        </div>
                        <ClickSwitch
                          flag={this.state.notifyCid}
                          onChange={(flag) => {
                            this.setState({ notifyCid: flag });
                            setUseNotifyCid(flag);
                          }}
                        />
                        <div className="pos-element-block-content-text5">
                          <div className="pos-element-block-content-field-port">
                            <Input
                              type="number"
                              value={this.state.cidPort}
                              onFocus={() => {}}
                              autoComplete="off"
                              placeholder="Port"
                              style={{ borderRadius: '7px', fontSize: '11px' }}
                              maxLength={6}
                              onChange={(e) => {
                                this.setState({
                                  cidPort: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div
                            className={skinType === "GOGOIT" ? "gogoit-pos-element-block5-content-btn2" : "pos-element-block5-content-btn2"}
                            onClick={() => {
                              this.onChangeCidPort();
                            }}>
                            변경
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="pos-element-block-content-text4">
                          자동 접수
                        </div>
                        <ClickSwitch
                            flag={this.state.useAutoConfirmOrder}
                            onChange={(flag) => {
                              this.setState({useAutoConfirmOrder: flag});
                              setUseAutoConfirmOrder(flag);
                            }}
                        />
                        <div className="pos-element-block-content-text5">
                          <div>픽업 :&nbsp;
                          <Select
                              style={{
                                width: '5rem',
                              }}
                              defaultValue={this.getPickupTimeText(this.state.autoConfirmPickupTime)}
                              onSelect={(value) => {
                                this.setState({autoConfirmPickupTime: value});
                                setAutoConfirmPickupTime(value);
                              }}>
                            {pickupTimeValue.map((value, index) => {
                              if (index === 0) return null;
                              return (
                                  <Select.Option key={index} value={value}>
                                    {this.getPickupTimeText(value)}
                                  </Select.Option>
                              );
                            })}
                          </Select>
                          </div>
                        </div>
                      </div>
                      {/* <div>
                        <div className="pos-element-block-content-text4-1">
                          간편동 사용
                        </div>
                        <ClickSwitch
                          flag={this.props.posReducer.simpleDongSetting}
                          onChange={(value) => {
                            this.onChangeSimpleDongSetting(value, false);
                          }}
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* 알림설정 - 모바일*/}
                <div className="pos-element-block mobile">
                  <div className="pos-element-block-content">
                    <div>
                      <div className="pos-element-block-content-text">
                        전체알림
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyAll}
                        onChange={(flag) => {
                          this.setState({
                            notifyAll: flag,
                            notifyOrderNew: flag,
                            notifyOrderAssign: flag,
                            notifyOrderPickUp: flag,
                            notifyOrderComplete: flag,
                            notifyOrderEtc: flag,
                            notifyChat: flag,
                          });
                          SetUseNotifyOrderNew(flag);
                          SetUseNotifyOrderAssign(flag);
                          SetUseNotifyOrderPickUp(flag);
                          SetUseNotifyOrderComplete(flag);
                          SetUseNotifyOrderEtc(flag);
                          SetUseNotifyChat(flag);
                        }}
                      />
                    </div>
                    <div>
                      <div className="pos-element-block-content-text">
                        채팅알림
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyChat}
                        onChange={(flag) => {
                          this.setState({
                            notifyChat: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyOrderEtc,
                          });
                          SetUseNotifyChat(flag);
                        }}
                      />
                    </div>
                    <div>
                      <div className="pos-element-block-content-text2">
                        접수
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderNew}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderNew: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderNew(flag);
                        }}
                      />
                    </div>
                    <div>
                      <div className="pos-element-block-content-text2">
                        배정
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderAssign}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderAssign: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderAssign(flag);
                        }}
                      />
                    </div>
                    <div>
                      <div className="pos-element-block-content-text2">
                        픽업
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderPickUp}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderPickUp: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderPickUp(flag);
                        }}
                      />
                    </div>
                    <div>
                      <div className="pos-element-block-content-text2">
                        완료
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderComplete}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderComplete: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderEtc &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderComplete(flag);
                        }}
                      />
                    </div>
                    <div>
                      <div className="pos-element-block-content-text2">
                        기타
                      </div>
                      <ClickSwitch
                        flag={this.state.notifyOrderEtc}
                        onChange={(flag) => {
                          this.setState({
                            notifyOrderEtc: flag,
                            notifyAll:
                              flag &&
                              this.state.notifyOrderNew &&
                              this.state.notifyOrderAssign &&
                              this.state.notifyOrderPickUp &&
                              this.state.notifyOrderComplete &&
                              this.state.notifyChat,
                          });
                          SetUseNotifyOrderEtc(flag);
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* 블라인드 */}
                <div className="pos-element-block2-content">
                  <div className="pos-element-block2-content-text">
                    블라인드 설정
                  </div>

                  <div
                    className={skinType === "GOGOIT" ? "gogoit-pos-element-setting-blind-btn" : "pos-element-setting-blind-btn"}
                    onClick={() => {
                      this.setState({ blindModalOpen: true });
                    }}>
                    블라인드확인
                  </div>
                </div>
                {/* 예치금 충전 자동결제-기본형 */}
                <div className="pos-element-block3 desk">
                  <div className="pos-element-block3-content">
                    <div className="pos-element-block3-content-text">
                      예치금 충전 자동결제
                    </div>
                    <ClickSwitch
                      flag={
                        this.state.autoCharge && this.state.autoCharge.enabled
                      }
                      className="pos-element-block3-content-img"
                      onChange={(flag) => this.onChangeAutoCharge(flag)}
                    />
                    <div
                      className={skinType === "GOGOIT" ? "gogoit-pos-element-block3-content-btn" : "pos-element-block3-content-btn"}
                      onClick={() => {
                        this.setState({ chargeModalOpen: true });
                      }}>
                      카드설정
                    </div>

                    <div className="pos-element-block3-content-element">
                      <div className="pos-element-block3-content-element-text">
                        <div className="sub-dots" />
                        서비스 이용상태 : 사용중
                      </div>
                      {/* <div className="pos-element-block3-content-element-text2">
                                                <div className="sub-dots" />
                                                    월 이용료 : 서비스 이용 시
                                                    <div className="pos-element-block3-content-element-text3">
                                                    9,900원
                                                    </div>
                                                <div className="pos-element-block3-content-element-text4">
                                                    예치금 차감
                                                </div>
                                            </div> */}
                      <div className="pos-element-block3-content-element-text2">
                        <div className="sub-dots" />
                        자동결제 상태 :{' '}
                        {this.state.autoCharge && this.state.autoCharge.enabled
                          ? `활성`
                          : `비활성`}
                      </div>
                      <div className="pos-element-block3-content-element-text2">
                        <div className="sub-dots" />
                        자동결제 수단 :{' '}
                        {this.state.autoCharge.cardNum
                          ? `신용카드(${this.state.autoCharge.cardNum.substr(
                              0,
                              4
                            )}-****-****-****)`
                          : `미설정`}
                      </div>
                      <div className="pos-element-block3-content-element-text2">
                        <div className="sub-dots" />
                        자동결제 금액 :{' '}
                        {this.state.autoCharge.amount
                          ? `${comma(this.state.autoCharge.amount)}원`
                          : `미설정`}
                      </div>
                    </div>
                    <div className="pos-element-block3-content-element-img ">
                      <img
                        style={{ display: 'inline' }}
                        src={image.ChargeIcon}
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                {/* 예치금 충전 자동결제-반응형 */}
                <div className="pos-element-block3 pos">
                  <div className="pos-element-block3-content">
                    <div>
                      <div>예치금 충전 자동결제</div>
                      <ul>
                        <li>서비스 이용상태 : 사용중</li>
                        <li>
                          자동결제 상태 :{' '}
                          {this.state.autoCharge &&
                          this.state.autoCharge.enabled
                            ? `활성`
                            : `비활성`}
                        </li>
                      </ul>
                      <ul>
                        <li>
                          자동결제 수단 :{' '}
                          {this.state.autoCharge.cardNum
                            ? `신용카드(${this.state.autoCharge.cardNum.substr(
                                0,
                                4
                              )}-****-****-****)`
                            : `미설정`}
                        </li>
                        <li>
                          자동결제 금액 :{' '}
                          {this.state.autoCharge.amount
                            ? `${comma(this.state.autoCharge.amount)}원`
                            : `미설정`}
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ClickSwitch
                        flag={
                          this.state.autoCharge && this.state.autoCharge.enabled
                        }
                        className="pos-element-block3-content-img"
                        onChange={(flag) => this.onChangeAutoCharge(flag)}
                      />

                      <div
                        className={skinType === "GOGOIT" ? "gogoit-pos-element-block3-content-btn" : "pos-element-block3-content-btn"}
                        onClick={() => {
                          this.setState({ chargeModalOpen: true });
                        }}>
                        카드설정
                      </div>

                      <div className="pos-element-block3-content-element-img ">
                        <img
                          style={{ display: 'inline' }}
                          src={image.ChargeIcon}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* 예치금 충전 자동결제- 모바일형*/}
                <div className="pos-element-block3 mobile">
                  <div className="pos-element-block3-content">
                    <div className="pos-element-block3-content-text">
                      예치금 충전 자동결제
                    </div>
                    <ClickSwitch
                      flag={
                        this.state.autoCharge && this.state.autoCharge.enabled
                      }
                      className="pos-element-block3-content-img"
                      onChange={(flag) => this.onChangeAutoCharge(flag)}
                    />
                    <div
                      className={skinType === "GOGOIT" ? "gogoit-pos-element-block3-content-btn" : "pos-element-block3-content-btn"}
                      onClick={() => {
                        // console.log('this.state.autoCharge');
                        // console.log(this.state.autoCharge);
                        this.setState({ chargeModalOpen: true });
                      }}>
                      카드설정
                    </div>
                    <div className="pos-element-block3-content-element-img mobileoff">
                      <img
                        style={{ display: 'inline' }}
                        src={image.ChargeIcon}
                        alt=""
                      />
                    </div>
                    <div className="pos-element-block3-content-element">
                      <div className="pos-element-block3-content-element-text">
                        <div className="sub-dots" />
                        서비스 이용상태 : 사용중
                      </div>
                      <div className="pos-element-block3-content-element-text2">
                        <div className="sub-dots" />
                        자동결제 상태 :{' '}
                        {this.state.autoCharge && this.state.autoCharge.enabled
                          ? `활성`
                          : `비활성`}
                      </div>
                      <div className="pos-element-block3-content-element-text2">
                        <div className="sub-dots" />
                        <p>자동결제 수단 : </p>
                        <p>
                          {this.state.autoCharge.cardNum
                            ? `신용카드(${this.state.autoCharge.cardNum.substr(
                                0,
                                4
                              )}-****-****-****)`
                            : `미설정`}
                        </p>
                      </div>
                      <div className="pos-element-block3-content-element-text2">
                        <div className="sub-dots" />
                        자동결제 금액 :{' '}
                        {this.state.autoCharge.amount
                          ? `${comma(this.state.autoCharge.amount)}원`
                          : `미설정`}
                      </div>
                    </div>
                  </div>
                </div>

                {/* 마케팅 수신 동의 */}
                <div className="pos-element-block5 desk">
                  <div className="pos-element-block5-content">
                    <div className="pos-element-block5-content-text">
                      마케팅 수신동의
                    </div>
                    <ClickSwitch
                      flag={this.props.loginReducer.loginInfo.agreeSms}
                      className="pos-element-block5-content-img"
                      onChange={(flag) => this.onChangeAgreeSms(flag)}
                    />
                    <div className="pos-element-block5-content-element">
                      <div className="pos-element-block5-content-element-text">
                        <div className="sub-dots" />
                        SMS로 공지사항 등 안내
                        <div className="pos-element-block5-content-element-text-sub">
                          와 이벤트정보를 받습니다.
                        </div>
                      </div>
                    </div>

                    <div className="pos-element-block5-content-element-img">
                      <img
                        style={{ display: 'inline' }}
                        src={image.MarketingIcon}
                        className="pos-img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                {/* 냠냠박스 - 타 배달앱 */}
                <div className="pos-element-block6 desk">
                  <div className="pos-element-block8-content">
                    <div className="pos-element-block8-content-text">
                      {string.name} - 배달특급
                    </div>
                    <div
                      className={skinType === "GOGOIT" ?"gogoit-pos-element-block8-content-btn" : "pos-element-block8-content-btn"}
                      onClick={() => {}}>
                      설치하기
                    </div>
                    <div className="pos-element-block8-content-element">
                      <div className="pos-element-block8-content-element-text">
                        <div className="sub-dots" />타 배달앱 서비스 신청
                      </div>
                    </div>
                    <div className="pos-element-block8-content-element-img">
                      <img
                        style={{ display: 'inline' }}
                        src={image.PeristIcon}
                        className="pos-img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                {/* 주소목록 & 마케팅 & 타배달앱 - 반응형 */}
                <div className="pos-element-box pos">
                  <div>
                    <div>마케팅 수신동의</div>
                    <ClickSwitch
                      flag={this.props.loginReducer.loginInfo.agreeSms}
                      className="pos-element-block10-content-img"
                      onChange={(flag) => this.onChangeAgreeSms(flag)}
                    />

                    <ul>
                      <li> SMS로 공지사항 등 안내와 이벤트정보를 받습니다.</li>
                    </ul>
                  </div>

                  <div>
                    <div>{string.name} - 배달특급</div>
                    <div className={skinType === "GOGOIT" ? "gogoit-pos-bottom-btn" : "pos-bottom-btn"} onClick={() => {}}>
                      설치하기
                    </div>
                    <ul>
                      <li> 타 배달앱 서비스 신청</li>
                    </ul>
                    <img
                      style={{ display: 'inline' }}
                      src={image.PeristIcon}
                      alt=""
                      className="pos-bottom-img"
                    />
                  </div>
                </div>

                {/* 주소목록 & 마케팅 & 타배달앱 - 모바일형 */}
                <div className="pos-element-box mobile">
                  <div>
                    <div>마케팅 수신동의</div>
                    <ClickSwitch
                      flag={this.props.loginReducer.loginInfo.agreeSms}
                      className="pos-element-block3-content-img"
                      onChange={(flag) => this.onChangeAgreeSms(flag)}
                    />
                    <ul>
                      <li> SMS로 공지사항 등 안내와 이벤트 정보를 받습니다.</li>
                    </ul>
                  </div>

                  <div>
                    <div>{string.name} - 배달특급</div>
                    <div className={skinType === "GOGOIT" ? "gogoit-pos-bottom-btn" : "pos-bottom-btn"} onClick={() => {}}>
                      설치하기
                    </div>
                    <ul>
                      <li> 타 배달앱 서비스 신청</li>
                    </ul>
                  </div>

                  <div>
                    <div>키보드 설정</div>
                    <ClickSwitch
                      flag={this.state.keyboardSetting}
                      className="pos-element-block3-content-img"
                      onChange={(flag) => {
                        this.setState({
                          keyboardSetting: flag,
                        });
                        setVrKeyboardSetting(flag);
                      }}
                    />
                    <ul>
                      <li>가상 키보드 사용여부를 설정합니다.</li>
                    </ul>
                  </div>

                  {/* <div>
                    <div>주문상태창 설정</div>
                    <ClickSwitch
                      flag={this.props.posReducer.orderStatusTable}
                      className="pos-element-block3-content-img"
                      onChange={(value) =>
                        this.onChangeOrderStatusSetting(value, false)
                      }
                    />
                    <ul>
                      <li>배달현황의 주문상태창 표시여부를 설정합니다.</li>
                    </ul>

                  </div> */}
                </div>
                {/* 키보드 설정 */}
                <div className="pos-element-block10 desk">
                  <div className="pos-element-block10-content">
                    <div className="pos-element-block10-content-text">
                      키보드 설정
                    </div>
                    <ClickSwitch
                      flag={this.state.keyboardSetting}
                      className="pos-element-block10-content-img"
                      onChange={(flag) => {
                        this.setState({
                          keyboardSetting: flag,
                        });
                        setVrKeyboardSetting(flag);
                      }}
                    />
                    <div className="pos-element-block10-content-element">
                      <div className="pos-element-block5-content-element-text">
                        <div className="sub-dots" />
                        가상 키보드 사용여부를 설정합니다.
                      </div>
                    </div>

                    <div className="pos-element-block10-content-element-img">
                      <img
                        style={{
                          opacity: 0.3,
                          width: 80,
                          height: 80,
                          display: 'inline',
                        }}
                        src={image.SettingKeyboardIcon}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="pos-element-block10 desk" style={{marginLeft: '21px'}}>
                  <div className="pos-element-block10-content">
                    <div className="pos-element-block10-content-text">
                      멀티포스 설정
                    </div>
                    <ClickSwitch
                      flag={this.state.multiPosSetting}
                      className="pos-element-block10-content-img"
                      onChange={(flag) => {
                        this.setState({
                          multiPosSetting: flag,
                        });
                        setMultiPosSettings(flag);
                      }}
                    />
                    <div className="pos-element-block10-content-element">
                      <div className="pos-element-block5-content-element-text">
                        <div className="sub-dots" />
                        멀티포스 사용여부를 설정합니다.
                      </div>
                    </div>

                    <div className="pos-element-block10-content-element-img">
                      <img
                        style={{
                          opacity: 0.3,
                          width: 80,
                          height: 80,
                          display: 'inline',
                        }}
                        src={image.LinkIcon}
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                {/* 주문상태창 표시 */}
                {/* <div className="pos-element-block10 desk">
                  <div className="pos-element-block10-content">
                    <div className="pos-element-block10-content-text">
                      주문상태창 설정
                    </div>
                    <ClickSwitch
                      flag={this.props.posReducer.orderStatusTable}
                      className="pos-element-block10-content-img"
                      onChange={(value) =>
                        this.onChangeOrderStatusSetting(value, false)
                      }
                    />
                    <div className="pos-element-block10-content-element">
                      <div className="pos-element-block5-content-element-text">
                        <div className="sub-dots" />
                        배달현황의 주문상태창 표시여부를 설정합니다.
                      </div>
                    </div>

                    <div className="pos-element-block10-content-element-img">
                      <img
                        style={{ opacity: 0.3, width: 80, height: 80 }}
                        src={
                          require("../img/body/setting_orderStatusTableSetting.png")
                            .default
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </div> */}
                {/* 키보드 설정 -포스*/}
                <div className="pos-element-block10 pos">
                  <div>
                    <div>키보드 설정</div>
                    <ClickSwitch
                      flag={this.state.keyboardSetting}
                      className="pos-element-block10-content-img"
                      onChange={(flag) => {
                        this.setState({
                          keyboardSetting: flag,
                        });
                        setVrKeyboardSetting(flag);
                      }}
                    />
                    <ul>
                      <li>가상 키보드 사용여부를 설정합니다.</li>
                    </ul>
                  </div>
                </div>

                {/* 멀티포스설정 -포스*/}
                <div className="pos-element-block10 pos">
                  <div>
                    <div>멀티포스 설정</div>
                    <ClickSwitch
                      flag={this.state.multiPosSetting}
                      className="pos-element-block10-content-img"
                      onChange={(flag) => {
                        this.setState({
                          multiPosSetting: flag,
                        });
                        setMultiPosSettings(flag);
                      }}
                    />
                    <ul>
                      <li>멀티포스 사용여부를 설정합니다.</li>
                    </ul>
                  </div>
                </div>
                {/* 주문상태창 표시-포스 */}
                {/* <div className="pos-element-block10 pos">
                  <div>
                    <div>주문상태창 설정</div>
                    <ClickSwitch
                      flag={this.props.posReducer.orderStatusTable}
                      className="pos-element-block10-content-img2"
                      onChange={(value) =>
                        this.onChangeOrderStatusSetting(value, false)
                      }
                    />
                    <ul>
                      <li>배달현황의 주문상태창 표시여부를 설정합니다.</li>
                    </ul>

                  </div>
                </div> */}
              </div>
            </div>
          )}
          {/* 간편동설정 */}
          {this.state.settingType === 2 && (
            <div className="simpleDong-elem mobileoff">
              <div>
                <div className="simpledong-title">간편동 사용 목록</div>
                <div className="simpleDong-wrap">
                  {this.state.dong.map((row, index) => {
                    if (row.idx === 0 || !row.quickMenu) return <></>;
                    else // console.log(index);
                    return (
                      <div
                        key={index}
                        className={skinType === "GOGOIT" ? "gogoit-simpleDong-box" : "simpleDong-box"}
                        onClick={() => {
                          this.setState({
                            selectedDong: this.state.selectedDong.concat(row),
                            dong: this.state.dong.filter(
                              (x) => x.idx !== row.idx
                            ),
                          });
                        }}>
                        {row.name}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div>
                <div className="simpledong-title">간편동 제외 목록</div>
                <div className="simpleDong-wrap">
                  {this.state.selectedDong.map((row, index) => {
                    if (row.idx === 0 || !row.quickMenu) return <></>;
                    else
                      return (
                        <div
                          key={index}
                          className="simpleDong-box colorChange"
                          onClick={() => {
                            this.setState({
                              dong: this.state.dong.concat(row),
                              selectedDong: this.state.selectedDong.filter(
                                (x) => x.idx !== row.idx
                              ),
                            });
                          }}>
                          {row.name}
                        </div>
                      );
                  })}
                </div>
              </div>
              <div className="setting-element-block3 mobileoff">
                <div
                  className={skinType === "GOGOIT" ? "gogoit-setting-element-block3-btn2" : "setting-element-block3-btn2"}
                  onClick={() => {
                    this.handleSubmit();
                  }}>
                  저장하기
                </div>
              </div>
            </div>
          )}

          {
            this.state.settingType === 3 && <YogiyoSetting />
          }

          {this.props.branchReducer.branchInfo.dwServiceType === 2 &&
            this.state.chargeModalOpen && (
              <PaystoryChargeModal
                autoPay
                autoPayData={this.state.autoCharge}
                getAutoCharge={this.getAutoCharge}
                close={() => this.setState({ chargeModalOpen: false })}
                loginInfo={this.props.loginReducer.loginInfo}
              />
            )}

          {this.props.branchReducer.branchInfo.dwServiceType === 1 && (
            <ChargeModal
              isOpen={this.state.chargeModalOpen}
              autoPay
              autoPayData={this.state.autoCharge}
              getAutoCharge={this.getAutoCharge}
              close={() => this.setState({ chargeModalOpen: false })}
              loginInfo={this.props.loginReducer.loginInfo}
            />
          )}
          <BlindModal
            isOpen={this.state.blindModalOpen}
            close={() => this.setState({ blindModalOpen: false })}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, posReducer, branchReducer } = state;
  return { loginReducer, posReducer, branchReducer };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      agreeSms,
      setKeyboardSetting,
      setVolumeSetting,
      setMultiPosSetting,
      updateCalculateHour,
      setBranchInfo,
    },
    dispatch
  );
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Setting)
);
